<template>
  <div>
    <title-row
      title="Ütemzések"
      :subtitle="dataTable.itemsLength === -1 ? 'Betöltés...' : `${dataTable.itemsLength} ütemzés van a rendszerben`"
      :breadcrumb-items="[
        {
          text: 'Ütemzések',
          disabled: true,
        },
      ]">

      <template #buttons>
        <title-row-button v-if="hasRight('SCHEDULE_WRITE')" :to="{ name: 'NewSchedule' }" title="Hozzáadás">
          <v-icon left>mdi-plus</v-icon>
          Új ütemzés
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :md="4">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                dense
                clearable
                hide-details
                filled />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps">
        <template #[`item.access_level_schedule`]="{ item }">
          <span v-if="item.access_level_schedule.length === 0" class="red--text">
            <v-icon small color="error">mdi-close</v-icon>
          </span>
          <span v-else class="green--text">
            <v-icon small color="success">mdi-check</v-icon>
          </span>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('SCHEDULE_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm mx-2"
            :to="{ name: 'ScheduleEditor', params: { id: item.id } }"
            title="Szerkesztés">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('SCHEDULE_DELETE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm mx-2"
            @click="deleteSchedule(item)"
            title="Törlés">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'ScheduleList',
      fetchItems: this.fetchScheduleGroups,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Hozzáférési szint(ek)hez rendelve', sortable: false, value: 'access_level_schedule' },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
      },
      searchTimeout: null,
    };
  },
  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
      };
    },

    async deleteSchedule(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> ütemzés törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          await this.$http.get(`schedule-groups/delete/${item.id}`);
          this.fetchScheduleGroups();
          this.$dialog.notify.info('Az ütemzés törölve!');
        } catch (e) {
          console.error(e);
        }
      }
    },

    async fetchScheduleGroups() {
      this.loading = true;
      try {
        const data = JSON.parse(JSON.stringify(this.search));
        data.sort_by = this.options.sortBy || [''];
        data.sort_desc = this.options.sortDesc || [false];
        const response = await this.$http.post('schedule-groups/list', this.options);
        this.dataTable.items = response.schedule_groups;
        this.dataTable.itemsLength = response.schedule_groups_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
      };
    }
  }
};
</script>
